import { render, staticRenderFns } from "./PFavoriteButton.vue?vue&type=template&id=07cc995c&scoped=true&"
import script from "./PFavoriteButton.vue?vue&type=script&lang=ts&"
export * from "./PFavoriteButton.vue?vue&type=script&lang=ts&"
import style0 from "./PFavoriteButton.vue?vue&type=style&index=0&id=07cc995c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc995c",
  null
  
)

export default component.exports